<template>
    <div class="h-100 bip-form">
        <bip-card :showForm="showForm"
                  :bip="bipProjectData"
                  :variant="selVersion"
                  :location="location"

                  :abp-base="abpBase"
                  :reg-abp-base="abpBase"
                  :spf-list="spfList"

                  :region-list="regionList"
                  :data-type-list="dataTypeList"
                  :direction-list="directionList"
                  :gp-list="gpList"
                  :exp-types="expTypes"

                  :bip-cif-list="bipCifList"
                  :criteria-values="criteriaValues"
                  :bip-link-criterias="bipLinkCriterias"
                  :bip-link-types="bipLinkTypes"
                  :dict-unit="dictUnit">
        </bip-card>
    </div>
</template>

<script>
    import 'bootstrap/dist/css/bootstrap.css';
    import 'bootstrap-vue/dist/bootstrap-vue.css';
    import store from '@/services/store';
    import BipCard from '@/modules/budget/bip/bip-card.vue';
    import {
        itemNameLocale,
        nameLocale,
        defineBip,
        findItem,
        sortByField,
        getRowKey,
        initLogging,
        makeToast,
        postData,
        trMsg,
        MSG_SMS,
        expTypes, getInitialDicts, DICT_CONFIG, pkgDicts, processPkgDicts
    } from "./bip-types";

    export default {
        name: 'bip-card-out',
        components: { BipCard },
        data() {
            return {
                location: null,
                selVersion: null,
                regionList: [],
                bipProjectData: null,

                spfList: [],
                ...getInitialDicts(),
                // dataTypeList: [],
                // directionList: [],
                // gpList: [],
                // bipCifList: [],
                // criteriaValues: new Map(),
                // bipLinkCriterias: [],
                // bipLinkTypes: [],
                // dictUnit: [],
                // expTypes: expTypes,

                detailFields: [],
                ebkMap: new Map(),
                abpBase: [],

                showForm: false
            };
        },

        async mounted() {
            await this.getLocation();
            // await this.loadBipPackageDicts();
            await this.procPkgDicts();

            const urlArray = location.hash.split('?')
            if (urlArray.length>0) {
                const queryString = urlArray[1];
                const urlParams = new URLSearchParams(queryString);
                const bip_code = urlParams.get('bip_code');
                const variant = urlParams.get('variant');
                if (bip_code !== null && variant !== null) {
                    await this.loadBipPackage(bip_code, variant);
                }
            }
        },

        methods: {
            async getLocation() {
                try {
                    const response = await fetch("/api-py/get-budget-obl/" + store.state._instanceCode)
                        .then((response) => response.json());
                    this.location = response;
                } catch (error) {
                    makeToast(this, trMsg(this, MSG_SMS + 'error_request'),
                        '/get-budget-obl ' + error.toString());
                } finally {
                    initLogging('bip-free location', this.location);
                    if (this.location) {
                        await this.loadRegionList();
                    }
                }
            }, // запрос локации по глобальному коду области

            async loadBip(bip_code, variant) {
                try {
                    let response = await fetch('/api-py/bip-card/' + bip_code + '/' + variant);
                    response = await response.json();
                    this.bipProjectData = response;
                } catch (error) {
                    makeToast(this, 'danger', 'Ошибка запроса loadBip', error.toString());
                }

            }, // загрузка списка БИПов

            async loadBipPackageDicts() {

                const DICT_KEYS = [
                    'budget_data_types', 'bip_project_type_list', 'bip_project_object_list',
                    'agreement_status', 'program', 'unit', 'bip_cif_list',
                    'bip_link_types', 'bip_link_criterias', 'bip_criteria_values'
                ];

                try {
                    const response = await postData('/api-py/bip-package-dicts', DICT_KEYS);
                    initLogging('bip-free loadBipPackageDicts', response);

                    // Извлечение и обработка данных
                    const {
                        budget_data_types,
                        bip_project_type_list,
                        bip_project_object_list,
                        agreement_status,
                        program,
                        unit,
                        bip_cif_list,
                        bip_link_types,
                        bip_link_criterias,
                        bip_criteria_values
                    } = response;

                    // Основные присвоения
                    this.dataTypeList = budget_data_types;
                    this.directionList = bip_project_type_list.filter((row) => !['7', '8'].includes(row.code));
                    this.objectList = bip_project_object_list;
                    this.statusList = agreement_status.sort(sortByField('name_ru'));
                    this.gpList = program;
                    this.dictUnit = unit.sort(sortByField('code'));
                    this.bipCifList = bip_cif_list.sort(sortByField('code'));
                    this.bipLinkTypes = bip_link_types.sort(sortByField('id'));
                    this.bipLinkCriterias = bip_link_criterias;

                    // Массовая локализация
                    const collectionsToLocalize = [
                        this.dataTypeList, this.directionList, this.objectList,
                        this.statusList, this.gpList, this.dictUnit,
                        this.bipCifList, this.bipLinkTypes, this.bipLinkCriterias,
                        bip_criteria_values
                    ];
                    collectionsToLocalize.forEach(col => nameLocale(col));
                    this.directionList.forEach(item => nameLocale(item.object_types));

                    // Обработка критериев
                    this.criteriaValues = new Map(
                        bip_criteria_values.map((row) => [
                            getRowKey(row, ['criteria', 'link', 'year']),
                            row
                        ])
                    );

                    // Оптимизированная обработка bipLinkCriterias
                    this.bipLinkCriterias.forEach(blc => {
                        try {
                            const [cif] = this.bipCifList.filter(row => row.code === blc.criteria);
                            if (cif) {
                                Object.entries(cif)
                                    .filter(([key]) => !['id', 'begin_date', 'end_date'].includes(key))
                                    .forEach(([key, value]) => this.$set(blc, key, value));

                                this.$set(blc, 'unit_item',
                                    findItem(blc.unit, 'national_symbol', this.dictUnit));
                            }

                            const [blt] = this.bipLinkTypes.filter(row => row.id === blc.link);
                            if (blt) {
                                Object.entries(blt)
                                    .filter(([key]) => key !== 'id')
                                    .forEach(([key, value]) => this.$set(blc, key, value));

                                const setYear = (dateKey, yearKey) =>
                                    this.$set(blc, yearKey,
                                        blt[dateKey] ? new Date(blt[dateKey]).getFullYear() : null);

                                setYear('begin_date', 'begin_year');
                                setYear('end_date', 'end_year');
                            }
                        } catch (error) {
                            console.error(`Criteria error [${blc.id}]:`, error);
                        }
                    });

                } catch (error) {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request'),
                        '/bip-package-dicts ' + error.toString());
                }
            },

            async procPkgDicts() {
                const DICT_KEYS = Object.keys(DICT_CONFIG);

                try {
                    const response = await pkgDicts(this, DICT_KEYS);

                    await processPkgDicts(this, response);
                } catch (error) {
                    makeToast(this, 'danger',
                        trMsg(this, MSG_SMS + 'error_request'),
                        'procPkgDicts ' + error.toString());
                }
            },

            async loadBipPackage(bip_code, variant) {
                this.showForm = false;
                const params = {
                    variant: variant,
                    mode_code: 'bip',
                    mode: 'free',
                    bip_code: bip_code
                }
                try {
                    postData('/api-py/bip-free-package', params).then((resp) => {
                        const response = resp;
                        initLogging('bip-free loadBipPackage', response);

                        this.ebkMap = new Map(Object.entries(response.abpMap));

                        this.spfList = response.spfList.sort(sortByField('spf')).filter((row) => row.type === 4);
                        nameLocale(this.spfList, 'spf');

                        this.agrMap = new Map(Object.entries(response.agrMap));

                        this.bipProjectData = response.bipForm;
                        this.selVersion = response.version;

                        for (const ebk of this.ebkMap.values()) {
                            itemNameLocale(ebk, 'abp');
                            itemNameLocale(ebk.value, 'abp');
                            for (const prg of ebk.value.child) {
                                itemNameLocale(prg, 'prg');
                                itemNameLocale(prg.value, 'prg');
                                for (const ppr of prg.value.child) {
                                    itemNameLocale(ppr, 'ppr');
                                    itemNameLocale(ppr.value, 'ppr');
                                }
                            }
                            this.abpBase.push(ebk.value);
                        }

                        defineBip(this, this.bipProjectData, 'grade');

                        this.showForm = true;
                    });
                } catch (error) {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request'),
                        '/bip-package ' + error.toString());
                } finally {
                }
            },

            async loadRegionList() {
                try {
                    const response = await fetch("/api-py/get-kato-regions/" + this.location.code)
                        .then((response) => response.json());

                    for (const region of response) {
                        // для ГРЗ (AB >= 71) строка самого города должна остаться в списке (EAK-462)
                        if (region["code"].substring(2, 3) !== "0"
                            || parseInt(region["code"].substring(0, 2), 10) >= 71) {
                            try {
                                const locals = await fetch("/api-py/get-kato-localities/" + region["code"].substring(0, 4))
                                    .then((response) => response.json());
                                nameLocale(locals);
                                locals.sort(sortByField("code"));
                                this.$set(region, "localityList", locals);
                                this.regionList.push(region);
                            } catch (error) {
                                makeToast(this, "danger", "Ошибка запроса /get-kato-localities/"
                                    + region["code"].substring(0, 4), error.toString());
                            }
                        }
                    }
                } catch (error) {
                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request'),
                        '/get-kato-regions ' + error.toString());
                } finally {
                    nameLocale(this.regionList);
                    initLogging('bip-free regionList', this.regionList);
                }
            }, // загрузка районов по области
        }
    };
</script>